export function safe<T>(val: Exclude<T, null | undefined> | null | undefined) {
	if (val === null || val === undefined) {
		throw new Error('value should be defined!');
	}
	return val;
}
